import { render, staticRenderFns } from "./ProblemEdit.vue?vue&type=template&id=184d1ac1&scoped=true&"
import script from "./ProblemEdit.vue?vue&type=script&lang=js&"
export * from "./ProblemEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProblemEdit.vue?vue&type=style&index=0&id=184d1ac1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d1ac1",
  null
  
)

export default component.exports